angular.module("Main").controller("AutoShopController", ["$state", "$location", "$stateParams", "AuthenticationService", "SessionService",
    function ($state, $location, $stateParams, AuthenticationService, SessionService) {
        var vm = this;

        let email = $stateParams.email;
        let password = $stateParams.pwd;
        let clubId = $stateParams.cid;
        if (_.isUndefined($stateParams.id)) {
            var uuid = false;
        } else if($stateParams.id) {
            var uuid = $stateParams.id;
        }

        if (!_.isEmpty(clubId)) {
            if (_.isEmpty(email) || _.isEmpty(password)) {
                SessionService.setAuthDataId(clubId, uuid, false, uuid==='tt');
                $state.go("shop", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
            } else {
                SessionService.setAuthData(clubId, uuid, true, false);
                AuthenticationService.login(email, password).then(function (response) {
                    if (response != null) {

                        $state.go("shop", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
                    } else {
                        $state.go("no_access");
                    }
                }).catch(function () {
                    $state.go("no_access");
                });
            }
        } else
            $state.go("no_access");

    }]);